module.exports = __webpack_public_path__ + "static/eu-foot-00d9c28a0bf0ec5ef97d93f734985bc3.svg";